import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../utils/data/dataActions";
import * as accountsAction from "./accountsAction";
import AccountsForm from "./AccountsForm";

class AccountsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getData = this.getData.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.getData();
  }
  componentWillUpdate() {}
  getData() {
    this.props.accountsAction.getAccounts();
  }

  onSubmit(fields) {
    const accountProvinces = [];
    const accountBusinessUnits = [];
    Object.entries(fields.accountProvinces).map(
      ([accountProvinceId, accountProvinceFields]) => {
        accountProvinces.push({ accountProvinceId, ...accountProvinceFields });
      }
    );
    Object.entries(fields.accountBusinessUnits).map(
      ([accountBusinessUnitId, accountBusinessUnitFields]) => {
        accountBusinessUnits.push({
          accountBusinessUnitId,
          ...accountBusinessUnitFields,
        });
      }
    );

    Promise.all([
      this.props.accountsAction.updateAccounts({
        ...fields,
        accountProvinces,
        accountBusinessUnits,
      }),
    ]).then(() => this.getData());
  }

  render() {
    const { authLanguageCode, allLoaded } = this.props;
    const accounts = this.props.accounts;
    const accountProvinces = this.props.accountProvinces;
    const accountBusinessUnits = this.props.accountBusinessUnits;
    const provinces = this.props.provinces;
    const businessUnit = this.props.businessUnit;

    return (
      <div>
        {!!accounts.fetched && (
          <AccountsForm
            authLanguageCode={authLanguageCode}
            loaded={allLoaded}
            onSubmit={this.onSubmit}
            provinces={provinces}
            businessUnit={businessUnit}
            initialValues={{
              ...accounts,

              accountProvinces: accountProvinces,
              accountBusinessUnits: accountBusinessUnits,
            }}
          />
        )}
      </div>
    );
  }
}

AccountsPage.propTypes = {
  allLoaded: PropTypes.bool,
  authLanguageCode: PropTypes.string,
  dataActions: PropTypes.object,
  children: PropTypes.node,
  accounts: PropTypes.object,
  accountProvinces: PropTypes.object,
  accountBusinessUnits: PropTypes.object,
  provinces: PropTypes.array,
  businessUnit: PropTypes.array,
  accountsAction: PropTypes.object,
  businessUnitAction: PropTypes.object,
};

AccountsPage.contextTypes = {
  getData: PropTypes.func,
};

function mapStateToProps(state) {
  const accounts = state.accounts;
  const provinces = accounts.accountProvinces || [];
  const businessUnit = accounts.accountBusinessUnits || [];
  const accountBusinessUnits = {};
  const accountProvinces = {};
  for (const item of provinces) {
    accountProvinces[item.accountProvinceId] = item;
  }
  for (const item of businessUnit) {
    accountBusinessUnits[item.accountBusinessUnitId] = item;
  }

  return {
    businessUnits: state.data.accountBusinessUnits || [],
    recievables: state.data.accountRecievables || [],
    payables: state.data.accountPayables || [],
    provinces,
    accountProvinces,
    accountByProvinceFetched: provinces.fetched,
    accounts,
    businessUnit,
    accountBusinessUnits,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    accountsAction: bindActionCreators(accountsAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/AccountsPage.js